import { render, staticRenderFns } from "./ReservationSummary.vue?vue&type=template&id=773ef744&scoped=true"
import script from "./ReservationSummary.vue?vue&type=script&lang=js"
export * from "./ReservationSummary.vue?vue&type=script&lang=js"
import style0 from "./ReservationSummary.vue?vue&type=style&index=0&id=773ef744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773ef744",
  null
  
)

export default component.exports